import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["in", "children", "direction", "duration"];
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { jsx as _jsx } from "react/jsx-runtime";
const FadeSlideInTransition = _ref => {
  let {
      in: inProp,
      children,
      direction = 'bottom',
      duration = 500
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CSSTransition, Object.assign({
    in: inProp,
    timeout: duration,
    classNames: `fade-slide-transition-${direction}`,
    mountOnEnter: true,
    unmountOnExit: true,
    appear: true
  }, rest, {
    children: children
  }));
};
FadeSlideInTransition.displayName = 'FadeSlideInTransition';
FadeSlideInTransition.propTypes = {
  children: PropTypes.node.isRequired,
  direction: PropTypes.oneOf(['bottom', 'top']),
  in: PropTypes.bool.isRequired
};
export default FadeSlideInTransition;